import IntlUtils from "services/intl/utils";
import ContractApi from "./api";
import CommonUtils from "services/common/utils";
import MapActioner from "services/map/actioner";
import UserActioner from "services/user/actioner";
import ContractActionTypes from "./types";

class ContractActioner {
  static getContracts() {
    return (dispatch, getState) => {
      return ContractApi.getContracts().then((contracts) => {
        dispatch({
          type: ContractActionTypes.SET_CONTRACTS,
          contracts,
        });

        return contracts;
      });
    };
  }

  static setCurrentContract(contract) {
    return (dispatch) => {
      dispatch({
        type: ContractActionTypes.SET_CONTRACT,
        contract,
      });

      return Promise.resolve(contract);
    };
  }

  static switchContract(contractId) {
    return (dispatch, getState) => {
      const contracts = getState()?.Contract?.contracts || [];
      const selectedContract = contracts.find(
        (contract) => contract?.id === contractId
      );
      IntlUtils.setLocale(selectedContract);
      dispatch({
        type: ContractActionTypes.SWITCH_CONTRACT,
        contract: selectedContract,
      });

      return dispatch(UserActioner.initDataFromContractId(contractId)).then(
        () => {
          const currentModule = CommonUtils.getModuleFromPath(
            getState()?.router?.location?.pathname
          );
          dispatch(MapActioner.initFloorsDataFromModule(currentModule));
          return selectedContract;
        }
      );
    };
  }
}

export default ContractActioner;
